<!--
 * @Author       : Tom
 * @Date         : 2019-12-21 23:50:12
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 16:03:20
 * @FilePath     : /shop_front_end/src/views/shop_set/editor.vue
 * @Description  : 店铺设置 编辑
 -->
<template>
  <div class="shopset">
    <a-card :title="activeKey==2?'编辑PC端轮播图':activeKey==3?'编辑移动端轮播图':''" :bordered="false">

      <a-form class="storedata" :form="form">
        <a-form-item label="轮播图" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" style="position:relative">

          <!-- <a-avatar :size="64" icon="user" v-if="!userimg"/>
          <a-avatar :size="64" icon="user" v-else :src="userimg"/> -->
          <div>
			  <a-upload
			    :action="downloadURL"
			    listType="picture-card"
			    :fileList="fileList"
			    @preview="handlePreview"
			    @change="handleChange"
			    :headers="heads"
			    v-decorator="['fileList', { initialValue: fileList,rules: [{ required: true, message: '请上传轮播图!' }] }]"
			  >
			  
			    <div v-if="fileList.length < 1">
			      <a-icon type="plus" />
			      <div class="ant-upload-text">Upload</div>
			    </div>
			    
			  </a-upload>
			  <span v-if="activeKey==2" style="position: absolute; left: 110px; white-space: nowrap; top: 30px;color: #969DA8;">（建议上传400*240px的图片）</span>
			  <span v-else style="position: absolute; left: 110px; white-space: nowrap; top: 30px;color: #969DA8;">（建议上传690*280px的图片）</span>
		  </div>
          

          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>

        </a-form-item>

        <!-- <label style="position: relative;top:32px;left:65px;color:red">*</label> -->
        <a-form-item label="跳转类型" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-select style="width:420px;" @change="changeSel" allowClear placeholder="请选择跳转类型" v-model="nameMr">
              <a-select-option v-for="(item,index) in optionList" :key="index" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item v-if="navtype&&parameter" label="参数" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input @change="changeIpt" style="width:420px;" allowClear placeholder="请输入商品参数" v-decorator="['nav_sqy', { initialValue: nav_sqy,rules: [{ required: true, message: '请输入商品参数!' }] }]"></a-input>
        </a-form-item>
        <!-- <a-form-item v-if="navtype" label="链接" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input style="width:420px;" v-model="nav_url1" disabled allowClear placeholder="请输入商品链接" v-decorator="['nav_url1', {initialValue: nav_url1, rules: [{ required: true, message: 'Please input your note!' }] }]"></a-input>
        </a-form-item> -->
         <!-- v-decorator="['nav_url1', { rules: [{ required: true, message: '请选择跳转类型!' }] }]" -->
        <a-form-item label="链接" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-select style="width:420px;" @change="changeSel1" allowClear placeholder="请选择链接" v-model="ljMr">
              <a-select-option v-for="(item,index) in optionList1" :key="index" :value="item.url">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>

      <div class="foot">
        <a-button type="danger" class="btns" @click="onGoBack">取消</a-button>
        <a-button type="primary" @click="onFormBtn">保存</a-button>
      </div>
      
    </a-card>
  </div>
</template>

<script>
import { downloadURL } from "../../lib/config";
import { getToken } from "../../lib/tool";

export default {
  data(){
    return {
      downloadURL,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      userimg:'',
      name:'',
      shop_information:'',
      shop_range:'',
      tel:'',
      realname:'',
      address: '',
      ID_number: '',
      previewVisible: false,
      previewImage: '',
      fileList: [],
      heads: {},
      optionList: [],
      optionList1:[],
      nameMr:'',
      ljMr:'',

      navtype: '',
      nav_sqy: '',  //parameter
      nav_url: '',  //open_type
      nav_url1: '',  //url
      open_type: '',
      parameter: '',
      imgId: ''
    }
  },
  watch:{
      navtype(val){
        this.open_type = val
      //   this.optionList.filter(item=>{
      //     if(item.name == val){
      //       this.open_type = item.url
			
			// let data = {
			// 	obj: item.url
			// }
			// if(this.activeKey == 2){
			// 	data.type = 4
			// }
			
      //       this.$request.get('?module=pc_api&action=Mch&app=open_type', { params:data }).then(res => {
      //         let { code, message, parameter, url } = res

      //         if( code === 200 ){
      //           this.nav_url = url
      //           if(parameter){
			// 	  if(this.activeKey == 2){
			// 	  		this.nav_url1 =  url +'&'+parameter+'='+this.nav_sqy
			// 	  }else{
			// 	  		this.nav_url1 =  url +'?'+parameter+'='+this.nav_sqy
			// 	  }
      //           }else{
      //             this.nav_url1 =  url
      //           }
      //           this.parameter = parameter
      //         }
      //       })
      //     }
      //   })
        
        this.showNmae()
      },
  },
  mounted(){
	this.activeKey = localStorage.getItem('activeKey')

    let token = getToken("token");
    this.heads = {
      Authorizations: "Bearer " + token
    }
    
    this.initPage()
	  setTimeout(() => {
      this.showNmae()
    }, 1000);
  },
  methods:{
    changeSel(value){
      this.navtype = value
    },
    changeSel1(value){
      this.nav_url1 = value
    },
    showNmae(){
      let data = {
          type:this.activeKey == 2 ? this.activeKey:1,
          open_type: this.open_type,
          parameter:this.nav_sqy
        }
        this.$request.get('?module=pc_api&action=Mch&app=get_data', { params:data }).then(res => {
              this.optionList1 = res.data.list
              for(var i=0;i<this.optionList1.length;i++){
                if(this.optionList1[i].status == true){
                  this.ljMr = this.optionList1[i].name
                }
              }
        })
    },
    changeIpt(e){
      this.nav_sqy = e.target.value
      
	  if(this.activeKey == 2){
	  		this.nav_url1 = this.nav_url + '&'+ this.parameter + '=' + this.nav_sqy
	  }else{
	  		this.nav_url1 = this.nav_url + '?'+ this.parameter + '=' + this.nav_sqy
	  }
    },
    /**
     * @name 初始化页面
     */
    initPage(){
      this.imgId = this.$route.query.id
	  
	  let data = {
		  id: this.$route.query.id
	  }
	  if(this.activeKey == 2){
	  	 data.type = 4
	  }
	  
      this.$request.get('?module=pc_api&action=Mch&app=banner_modify_page', { params:data }).then(res => {
        let { code, message, data } = res

        if( code === 200 ){
          // data.list.filter(item=>{
          //   if(item.url == data.open_type){
          //     this.navtype = item.name
          //   }
          // })
          
          Object.assign(this,{
            optionList: data.open_list,
            fileList: [{
              response:{
                url: data.image
              },
              uid: '-1',
              name: "xxx.png",
              status: "done",
              url: data.image
            }],
            open_type: data.open_type,
            nav_url: data.open_type,
            nav_url1: data.page_url + data.parameter1,
            parameter: data.parameter1,
            nav_sqy: data.parameter
          })
          
          if(this.open_type == 1){
             this.nameMr = '分类'
          }else if(this.open_type == 2){
             this.nameMr = '商品'
          }else{
            this.nameMr = '首页'
          }
          
        }else{
          this.$message.warning(message)
        }
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    /**
    * @name 返回
    * */ 
    onGoBack(){
      this.$router.go(-1)
    },
    onFormBtn(){
      this.form.validateFields((err, values) => {
        if (!err) {
            let data = {
              id: this.imgId,
              open_type: this.nav_url,
              url: this.nav_url1,
              parameter: this.nav_sqy,
              pic_url: this.fileList[0].response.url
            }
			
			if(this.activeKey == 2){
				data.type = 4
			}
			
            this.$request.get('?module=pc_api&action=Mch&app=banner_modify',{ params: data }).then(res => {

                let { code, message } = res
                if(code === 200){
                  this.$message.success(message)
                  setTimeout(() => {
                      this.onGoBack()
                  },600)
                } else {
                 this.$message.warning(message)
                }

            })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>

.shopset {
  height: 100%;

  .storedata {
    margin-top: 40px;

    span {
      font-size:14px;
      font-weight:400;
      color:rgba(50,53,68,1);
    }
  }

  .foot {
    height: 68px;
    width: 100%;
    border-top: 1px solid #E9ECEF;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 60px;

    .btns {
      margin-right: 10px;
    }
  }

}

  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

</style>
